"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUseConditionSelector = void 0;
const fast_json_stable_stringify_1 = __importDefault(require("fast-json-stable-stringify"));
const react_1 = __importStar(require("react"));
const Col_1 = __importDefault(require("react-bootstrap/Col"));
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const Row_1 = __importDefault(require("react-bootstrap/Row"));
const SchemaInput_1 = require("../../components/SchemaInput/SchemaInput");
const hooks_1 = require("common/hooks");
const lodash_1 = require("lodash");
const components_1 = require("utils/components");
const url_1 = require("utils/url");
const properties_1 = require("./properties");
const schema_1 = require("./schema");
const getOptionKey = (propertyName, operator, optionValue) => {
    return optionValue !== undefined
        ? `${propertyName}:${operator}:${(0, fast_json_stable_stringify_1.default)(optionValue)}`
        : `${propertyName}:${operator}`;
};
const invokeSchemaHandler = (handlers, schema, s, searchInput) => {
    const handler = handlers[schema.schemaType];
    return (handler === null || handler === void 0 ? void 0 : handler(schema, s, searchInput)) || [];
};
const createUseConditionSelector = (schemaComponents) => ({ schema: baseSchema, hideTimeCondition, searchParamKey, unwrapped, }) => {
    // this is dangerous workaround to avoid type error
    const schema = baseSchema;
    const propertyList = (0, properties_1.usePropertyList)(schema);
    const s = (0, hooks_1.useStringIntl)();
    const { optionSource, optionMap } = (0, react_1.useMemo)(() => {
        const optionSource = propertyList
            .map((property) => {
            const options = invokeSchemaHandler(schema_1.schemaHandler, property.schema, s);
            return options.filter((option) => option).map((option) => {
                const title = property.statName ||
                    (0, hooks_1.resolveStringIntl)(property.title);
                return Object.assign(Object.assign({}, option), { label: option.hideLabel
                        ? option.optionLabel
                        : typeof option.optionLabel === "string"
                            ? `${title} : ${option.optionLabel}`
                            : title, fieldName: property.propertyName, fieldLabel: title, value: getOptionKey(property.propertyName, option.operator, option.optionValue) });
            });
        })
            .flat();
        const optionMap = Object.fromEntries(optionSource.map((option) => [option.value, option]));
        return { optionSource, optionMap };
    }, [schema, propertyList]);
    const searchParamAccessor = (0, url_1.useSearchParamAccessor)();
    const timeConditionAccessor = (0, hooks_1.useFieldAccessor)(searchParamAccessor, "t");
    const conditionAccessor = (0, hooks_1.useFieldAccessor)(searchParamAccessor, searchParamKey || "c");
    const [searchInput, setSearchInput] = (0, react_1.useState)();
    // <Select>に表示するためのoptionsを生成
    const generatedOptions = (0, react_1.useMemo)(() => {
        const options = Array.from((function* () {
            for (const optionItem of optionSource) {
                if (optionItem.handler) {
                    if (!searchInput)
                        continue;
                    const custom = optionItem.handler(searchInput);
                    if (custom) {
                        const option = Object.assign(Object.assign(Object.assign({ optionValue: searchInput }, custom), optionItem), { hasSearchInput: true });
                        option.label = `${option.fieldLabel} : ${option.optionLabel}`;
                        option.value = getOptionKey(option.fieldName, option.operator, option.optionValue);
                        yield option;
                    }
                }
                else {
                    yield optionItem;
                }
            }
        })());
        return options;
    }, [optionSource, searchInput]);
    // <Select>に表示するための、現在選択中のオプション
    const selectedConditions = (0, react_1.useMemo)(() => {
        const populateOption = (_option, optionValue) => {
            const handler = _option.valueHandler || _option.handler;
            if (handler) {
                const option = Object.assign(Object.assign({ optionValue }, handler.call(_option, optionValue)), _option);
                option.label = `${option.fieldLabel} : ${option.optionLabel}`;
                option.hasSearchInput = true;
                option.value = getOptionKey(option.fieldName, option.operator, option.optionValue);
                return option;
            }
            else {
                return _option;
            }
        };
        return Array.from((function* () {
            for (const [fieldName, fieldValue] of Object.entries(conditionAccessor.value || {})) {
                if (isObject(fieldValue)) {
                    for (const [operator, optionValue] of Object.entries(fieldValue)) {
                        if (operator === "$in") {
                            const options = Array.from((function* () {
                                for (const optionItem of optionValue) {
                                    const optionKey = getOptionKey(fieldName, undefined, optionItem);
                                    const _option = optionMap[optionKey];
                                    if (_option) {
                                        yield _option;
                                    }
                                }
                            })());
                            if (options.length === 1) {
                                for (const option of options) {
                                    yield option;
                                }
                            }
                            else if (options.length > 0) {
                                const option = options[0];
                                const { fieldName, fieldLabel } = option;
                                const operator = "$in";
                                const optionValue = options.map((option) => option.optionValue);
                                yield {
                                    fieldName,
                                    fieldLabel,
                                    optionLabel: "multiple",
                                    operator,
                                    optionValue,
                                    label: `${fieldLabel} : ${options
                                        .map((option) => option.optionLabel)
                                        .join(" or ")}`,
                                    keys: options.map((option) => option.value),
                                    value: getOptionKey(fieldName, operator, optionValue),
                                };
                            }
                        }
                        else {
                            const optionKey = getOptionKey(fieldName, operator, optionValue);
                            if (optionMap[optionKey]) {
                                yield optionMap[optionKey];
                            }
                            else {
                                const optionKey = getOptionKey(fieldName, operator);
                                const _option = optionMap[optionKey];
                                if (_option) {
                                    yield populateOption(_option, optionValue);
                                }
                            }
                        }
                    }
                }
                else {
                    const optionValue = fieldValue;
                    const optionKey = getOptionKey(fieldName, undefined, optionValue);
                    if (optionMap[optionKey]) {
                        yield optionMap[optionKey];
                    }
                    else {
                        const optionKey = getOptionKey(fieldName, undefined);
                        const _option = optionMap[optionKey];
                        if (_option) {
                            yield populateOption(_option, optionValue);
                        }
                    }
                }
            }
        })());
    }, [conditionAccessor.value, optionMap]);
    const [selectedOptions, setSelectedOptions] = (0, react_1.useState)(selectedConditions);
    (0, react_1.useEffect)(() => {
        handleApplyCondition(selectedOptions);
    }, [selectedOptions]);
    const onChangeOptions = (options, type) => {
        const optionArray = Array.isArray(options)
            ? options
            : options
                ? [options]
                : [];
        if (type === "select") {
            setSelectedOptions((prev) => {
                const others = prev.filter((op) => op.hasSearchInput);
                return [...others, ...optionArray];
            });
        }
        else {
            setSelectedOptions((prev) => {
                const others = prev.filter((op) => !op.hasSearchInput);
                return [...others, ...optionArray];
            });
        }
    };
    const handleApplyCondition = (0, react_1.useCallback)((options) => {
        const condition = {};
        const optionsArray = Array.isArray(options)
            ? options
            : options
                ? [options]
                : [];
        for (const option of optionsArray) {
            const { fieldName, fieldLabel, optionLabel, operator, optionValue } = option;
            let fieldCondition = condition[fieldName];
            if (operator) {
                if (isObject(fieldCondition) &&
                    (0, lodash_1.isEqual)(fieldCondition[operator], optionValue)) {
                    if (fieldCondition)
                        delete fieldCondition[operator];
                }
                else {
                    if (!fieldCondition || typeof fieldCondition !== "object") {
                        fieldCondition = {};
                    }
                    fieldCondition[operator] = optionValue;
                }
            }
            else {
                if (isObject(fieldCondition) && fieldCondition["$in"]) {
                    const arrayCondition = fieldCondition["$in"];
                    if (arrayCondition.includes(optionValue)) {
                        if (!fieldCondition || typeof fieldCondition !== "object") {
                            fieldCondition = {};
                        }
                        fieldCondition["$in"] = arrayCondition.filter((item) => item !== optionValue);
                    }
                    else {
                        arrayCondition.push(optionValue);
                    }
                }
                else {
                    if (fieldCondition === optionValue) {
                        fieldCondition = undefined;
                    }
                    else if (isObject(fieldCondition) ||
                        fieldCondition === undefined) {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        fieldCondition = optionValue;
                    }
                    else {
                        fieldCondition = { $in: [fieldCondition, optionValue] };
                    }
                }
            }
            if (fieldCondition !== undefined) {
                condition[fieldName] = fieldCondition;
            }
            else {
                delete condition[fieldName];
            }
        }
        conditionAccessor.setValue(condition);
    }, [conditionAccessor]);
    // 現在選択されているOptionKey
    const selectedOptionKeys = (0, react_1.useMemo)(() => {
        return new Set(selectedConditions
            .map((option) => [
            ...(option.keys ? option.keys : []),
            ...(option.value ? [option.value] : []),
        ])
            .flat());
    }, [selectedConditions]);
    const styles = (0, react_1.useMemo)(() => {
        return {
            placeholder: (provided) => (Object.assign(Object.assign({}, provided), { whiteSpace: "nowrap" })),
            multiValueLabel: (provided, state) => {
                return Object.assign(Object.assign({}, provided), { whiteSpace: "inherit" });
            },
            input: (provided, state) => {
                return Object.assign(Object.assign({}, provided), { minWidth: "150px" });
            },
            option: (provided, state) => {
                const selected = selectedOptionKeys.has(state.data.value);
                return Object.assign(Object.assign({}, provided), (selected
                    ? {
                        color: "hsl(0, 0%, 100%)",
                        background: "#2684FF",
                        ":active": { backgroundColor: "#2684FF" },
                    }
                    : {}));
            },
        };
    }, [selectedOptionKeys]);
    const onInputChange = (0, react_1.useCallback)((value, actionMeta) => {
        if (actionMeta.action !== "set-value") {
            setSearchInput(value);
        }
    }, []);
    const isMulti = false;
    const conditionSelector = (0, react_1.useMemo)(() => {
        const values = selectedConditions.filter((op) => !op.hasSearchInput);
        const selector = (react_1.default.createElement(components_1.ConditionSelect, { isMulti: isMulti || undefined, options: generatedOptions.filter((op) => !op.hasSearchInput), value: isMulti ? values : values[0] || null, onChange: (value) => onChangeOptions(value, "select"), hideSelectedOptions: false, closeMenuOnSelect: !isMulti, styles: styles, blurInputOnSelect: !isMulti, placeholder: "\u691C\u7D22\u6761\u4EF6\u3092\u5165\u529B", isClearable: true }));
        if (hideTimeCondition && unwrapped) {
            return selector || react_1.default.createElement(react_1.default.Fragment, null);
        }
        if (hideTimeCondition) {
            return (react_1.default.createElement(Form_1.default.Group, { as: Row_1.default, style: { padding: "10px 20px 10px 20px" } },
                react_1.default.createElement(Col_1.default, null, selector)));
        }
        return (react_1.default.createElement(Form_1.default.Group, { as: Row_1.default, style: { padding: "10px 20px 10px 20px" } },
            react_1.default.createElement(Form_1.default.Label, { column: true, sm: "1" }, "\u691C\u7D22\u6761\u4EF6"),
            selector && react_1.default.createElement(Col_1.default, { sm: "6" }, selector),
            react_1.default.createElement(Col_1.default, { sm: "5" },
                react_1.default.createElement(SchemaInput_1.SchemaInputInternal, { schemaComponents: schemaComponents, data: timeConditionAccessor.value, 
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    schema: { schemaType: "searchDate" }, onValueChange: timeConditionAccessor.setValue }))));
    }, [
        generatedOptions,
        selectedConditions,
        timeConditionAccessor.value,
        timeConditionAccessor.setValue,
    ]);
    const [selectedSearchOptions, setSelectedSearchOptions] = (0, react_1.useState)();
    const handleSelectSearchOption = (options) => {
        // handle clear
        if (!options) {
            onChangeOptions(null, "search");
        }
        setSelectedSearchOptions(options);
    };
    const handleSearch = () => {
        if (selectedSearchOptions) {
            onChangeOptions(selectedSearchOptions, "search");
        }
    };
    const filterComponent = (0, react_1.useMemo)(() => {
        var _a;
        const selected = selectedConditions.filter((op) => op.hasSearchInput);
        const tempOps = selectedSearchOptions
            ? Array.isArray(selectedSearchOptions)
                ? selectedSearchOptions
                : [selectedSearchOptions]
            : [];
        return (react_1.default.createElement(components_1.SearchInput, { options: generatedOptions.filter((op) => op.hasSearchInput), value: (_a = tempOps[0]) !== null && _a !== void 0 ? _a : selected[0], onChange: (value) => handleSelectSearchOption(value), onInputChange: onInputChange, styles: styles, inputValue: searchInput, onSearch: handleSearch, isClearable: true }));
    }, [selectedConditions, generatedOptions]);
    return {
        condition: conditionAccessor.value,
        timeCondition: timeConditionAccessor.value,
        conditionSelector,
        filterComponent,
    };
};
exports.createUseConditionSelector = createUseConditionSelector;
const isObject = (o) => !!o && typeof o === "object";
